import ReactMarkdown from 'react-markdown'
import { cmsRehypePlugins } from './cmsMarkdown'

const inlineElements = [
    'a',
    'b',
    'br',
    'code',
    'del',
    'em',
    'i',
    'ins',
    'mark',
    'p',
    's',
    'small',
    'span',
    'strong',
    'sub',
    'sup',
    'u',
]

// These fields historically contain HTML, not Markdown. Replace the Markdown
// AST with the original source before rehypeRaw and the common sanitizer run.
function preserveHtmlSource() {
    return (_tree: unknown, file: { value: unknown }) => ({
        type: 'root' as const,
        children: [{ type: 'html' as const, value: String(file.value) }],
    })
}

interface CmsHtmlProps {
    children: unknown
    inline?: boolean
}

// Descriptions keep their blocks; titles only unwrap safe inline formatting.
export const CmsHtml = ({ children, inline = false }: CmsHtmlProps) => (
    <ReactMarkdown
        remarkPlugins={[preserveHtmlSource]}
        rehypePlugins={cmsRehypePlugins}
        allowedElements={inline ? inlineElements : undefined}
        unwrapDisallowed={inline}
        components={
            inline ? { p: ({ children }) => <>{children}</> } : undefined
        }
    >
        {typeof children === 'string' ? children : ''}
    </ReactMarkdown>
)

export const CmsInlineHtml = ({ children }: { children: unknown }) => (
    <CmsHtml inline>{children}</CmsHtml>
)
